import { BsExclamationTriangle } from "../../assets/icons/vander";

export const LoadingData = ({ className = "" }) => {
  return (
    <div
      className={`alert bg-soft-warning fw-medium mb-0 ${className}`}
      role="alert"
    >
      <BsExclamationTriangle className="fs-5 align-middle me-1" /> Cargando...
    </div>
  );
};
